import(/* webpackMode: "eager", webpackExports: ["KidsPageView"] */ "/home/runner/work/multi-domain-website-framework/multi-domain-website-framework/apps/nippon-center-pakistan/src/components/audience/KidsPageView.tsx");
